import { render, staticRenderFns } from "./AuthNotifications.vue?vue&type=template&id=dce39980&scoped=true"
import script from "./AuthNotifications.vue?vue&type=script&lang=js"
export * from "./AuthNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dce39980",
  null
  
)

export default component.exports